import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { mapProps } from 'recompose';

import {
  AlbumFolderTagsFromAlbum,
  AlbumPhotoAlbumFolderTagsOnPhoto,
} from '../../../../../../graphql/queries/album-folder-tags';
import PhotoAlbumFolderTagsForm from './PhotoAlbumFolderTagsForm';
import {
  albumFolderTagCreate,
  albumPhotosAlbumFolderTagsCreate,
  albumPhotoAlbumFolderTagsDelete,
} from '../../../../../../graphql/mutations/album-folder-tags';

const withAlbumPhotoAlbumFolderTags = graphql(
  AlbumPhotoAlbumFolderTagsOnPhoto,
  {
    options: ({ photoId, albumId }) => ({
      variables: {
        photo_id: photoId,
        album_id: albumId,
      },
      fetchPolicy: 'network-only',
    }),
    props: ({ data: { photo, loading } }) => ({
      photo,
      loading,
    }),
    skip: ({ photoId }) => !photoId,
  },
);

const withAlbumFolderTags = graphql(AlbumFolderTagsFromAlbum, {
  options: ({ albumId }) => ({
    variables: {
      id: albumId,
    },
    fetchPolicy: 'network-only',
  }),
  props: ({ data: { album, loading } }) => ({
    album,
    loading,
  }),
});

const withAlbumFolderTagCreateMutation = graphql(albumFolderTagCreate, {
  props: ({ mutate, ownProps }) => ({
    createAlbumFolderTag: (
      albumFolderId,
      tagTemplateId,
      type,
      name,
      uniform,
      isMatchingTag,
    ) =>
      mutate({
        variables: {
          input: {
            album_folder_id: albumFolderId,
            tag_template_id: tagTemplateId,
            is_matching_tag: isMatchingTag,
            type,
            name,
            uniform,
          },
        },
        refetchQueries: [
          {
            query: AlbumFolderTagsFromAlbum,
            variables: {
              id: ownProps.albumId,
            },
          },
        ],
      }),
  }),
});

const withalbumPhotosAlbumFolderTagsCreateMutation = graphql(
  albumPhotosAlbumFolderTagsCreate,
  {
    props: ({ mutate }) => ({
      albumPhotosAlbumFolderTagsCreate: ({
        albumId,
        albumFolderTagIds,
        photo_ids: photoIds,
        album_photo_filter: albumPhotoFilter,
        album_photo_group_ids: photoGroupIds,
        ungrouped_only: ungroupedOnly,
        uploader_ids: uploaderIds,
      }) =>
        mutate({
          variables: {
            input: {
              album_id: albumId,
              album_folder_tags: albumFolderTagIds.map(id => ({
                album_folder_tag_id: id,
              })),
              photo_record_ids: photoIds,
              album_photo_filter: albumPhotoFilter,
              album_photo_group_ids: photoGroupIds,
              ungrouped_only: ungroupedOnly,
              uploader_ids: uploaderIds,
            },
          },
          refetchQueries:
            photoIds.selected_ids.length === 1
              ? // Only refetch this query when we're dealing with a single
                // photo.
                [
                  {
                    query: AlbumPhotoAlbumFolderTagsOnPhoto,
                    variables: {
                      album_id: albumId,
                      photo_id: photoIds.selected_ids[0],
                    },
                  },
                ]
              : [],
        }),
    }),
  },
);

const withAlbumPhotoAlbumFolderTagsDeleteMutation = graphql(
  albumPhotoAlbumFolderTagsDelete,
  {
    props: ({ mutate, ownProps }) => ({
      albumPhotoAlbumFolderTagsDelete: ids =>
        mutate({
          variables: {
            input: {
              ids,
            },
          },
          refetchQueries: [
            {
              query: AlbumPhotoAlbumFolderTagsOnPhoto,
              variables: {
                album_id: ownProps.albumId,
                photo_id: ownProps.photoId,
              },
            },
          ],
        }),
    }),
  },
);

export default compose(
  withRouter,
  mapProps(({ actionProps, match, ...props }) => ({
    albumId: actionProps?.albumId ?? match?.params.albumId,
    photoId: actionProps?.photoId ?? match?.params.photoId,
    actionProps,
    match,
    ...props,
  })),
  withAlbumPhotoAlbumFolderTags,
  withAlbumFolderTags,
  withAlbumFolderTagCreateMutation,
  withalbumPhotosAlbumFolderTagsCreateMutation,
  withAlbumPhotoAlbumFolderTagsDeleteMutation,
)(PhotoAlbumFolderTagsForm);
